import { USERS_HAS_ERROR, USERS_IS_LOADING, USERS_FETCH_DATA_SUCCESS, USERS_CREATE_CACHE} from '../actions/users'

   
export function usersHasError(state = null, action) {
    switch (action.type) {
        case USERS_HAS_ERROR:
            return action.error;

        default:
            return state;
    }
}

export function usersIsLoading(state = false, action) {
    switch (action.type) {
        case USERS_IS_LOADING:
            return action.isLoading;

        default:
            return state;
    }
}

export function users(state = [], action) {
    switch (action.type) {
        case USERS_FETCH_DATA_SUCCESS:
            return action.users;
   
        default:
            return state;
    }
}

export function usersCache(state = [], action) {
    switch (action.type) {
        case USERS_CREATE_CACHE:
            return action.usersCache;
          
        default:
            return state;
    }
}